import {
  COLUMNS_URL_QUERY_PARAM,
  FILTERS_URL_QUERY_PARAM,
  GROUPING_URL_QUERY_PARAM,
  PAGING_URL_QUERY_PARAM,
  SEARCH_URL_QUERY_PARAM,
  SORTS_URL_QUERY_PARAM,
  type StorageQueryParams,
} from '@/core/tables/types'
import type BaseWrapper from '@/data/models/wrappers/BaseWrapper'
import type { WrapperParams, WrapperTypesServicesKeys } from '@/services/wrappers/types'
import { isRecordUnknown } from '@/utils/typeGuards'

export type WrapperTableParams = Partial<StorageQueryParams>

export const isWrapperTableParams = (value: unknown): value is WrapperTableParams => {
  if (!isRecordUnknown(value)) {
    return false
  }

  const validKeys = [
    FILTERS_URL_QUERY_PARAM,
    SORTS_URL_QUERY_PARAM,
    GROUPING_URL_QUERY_PARAM,
    PAGING_URL_QUERY_PARAM,
    SEARCH_URL_QUERY_PARAM,
    COLUMNS_URL_QUERY_PARAM,
  ]
  return Object.keys(value).some((key) => validKeys.includes(key))
}

export type WrapperTableParamsToSave = Partial<Record<keyof WrapperTableParams, string[]>>

export type WrapperSetParamsResult = {
  canBeRestored: boolean
}

export interface WrapperTableServiceInterface {
  build(wrapperId: string, wrapperType?: WrapperTypesServicesKeys, model?: typeof BaseWrapper): any
  setParamsByTableData(
    wrapperId: string,
    params: WrapperTableParams,
    paramsToSave: WrapperTableParamsToSave,
    shouldReplaceState?: boolean,
  ): Promise<WrapperSetParamsResult>
  getTableParamKey(key: string, wrapperId: string): string
  getTableParam(wrapperId: string, key: string): unknown
  getTableParams(wrapperId: string): WrapperParams
  patchParams(wrapperId: string, params?: WrapperParams): WrapperParams
  isBuilt(wrapperId: string): boolean
  canBeRestored(wrapperId: string): boolean
  getAllTableParamsKeys(wrapperId: string): string[]
  removeParamsByTableKeys(wrapperId: string, keysToRemove: string[], shouldReplaceState: boolean): Promise<void>
  applyDefaults(
    wrapperId: string,
    defaultsProvider: () => WrapperTableParams,
    paramsToSave: WrapperTableParamsToSave,
  ): void
}
